import { useEffect, useState } from "react";
import Loading from "../loading/Loading";
import { Link, useParams } from "react-router-dom";
import { Alert, Button, Table } from "react-bootstrap";
import { getComunidadOrderHistory, getDiocesisOrderHistory, getRegionOrderHistory } from "../../controllers/orders";
import OrderDetailsModal from "../orders/OrderDetailsModal";
import OrderPaymentModal from "../orders/OrderPaymentModal";

function ComunidadOrderHistory({ type }) {
  const params = useParams();
  const [orders, setOrders] = useState();
  const [showPayModal, setShowPayModal] = useState(false);
  const [modalOrder, setModalOrder] = useState();

  let orgId;
  switch (type) {
    case 'region': orgId = params.regionId; break;
    case 'diocesis': orgId = params.diocesisId; break;
    case 'comunidad': orgId = params.comunidadId; break;
    default: orgId = null;
  }

  useEffect(() => {
    loadHistory();
  }, []);

  async function loadHistory() {
    let o;
    switch (type) {
      case 'region': o = await getRegionOrderHistory(orgId, 'material'); break;
      case 'diocesis': o = await getDiocesisOrderHistory(orgId, 'material'); break;
      case 'comunidad': o = await getComunidadOrderHistory(orgId, 'material'); break;
      default: orgId = null;
    }
    setOrders(o);
  }

  if (!orders) {
    return <Loading />
  }
  else if (!orders.length) {
    return <Alert variant="warning">No se encontraron órdenes.</Alert>
  }

  function showModal(e) {
    e.preventDefault();
    let o = orders.find(or => or.order_id === parseInt(e.target.dataset.order_id));
    setModalOrder(o);
    setShowPayModal(false);
  }
  function hideModal() {
    setModalOrder(false);
  }
  function launchPayModal() {
    setShowPayModal(true);
  }
  function showPaymentModal(e) {
    showModal(e);
    launchPayModal();
  }
  async function onPayment() {
    console.log(`modal order: ${modalOrder.order_id}`);
    loadHistory();
  }

  function renderOrders() {
    return orders.map((o, i) => {
      let fecha = new Date(o.createdAt);
      let total = 0;
      o.line_items.forEach(li => {
        total += parseInt(li.product_original_price) * li.quantity;
      });
      let payButton = '';
      if (o.order_status === 'Pago pendiente') {
        payButton = <Button variant="primary" data-order_id={o.order_id} onClick={showPaymentModal}>Pagar</Button>
      }
      return <tr key={`order-${o.order_id}`}>
        <td>{o.order_id}</td>
        <td>{fecha.toLocaleDateString()} {fecha.toLocaleTimeString()}</td>
        <td>{o.order_status}</td>
        <td>${total}</td>
        <td>
          {payButton} <Link onClick={showModal} data-order_id={o.order_id}>Ver detalles</Link>
        </td>
      </tr>
    });
  }

  return <>
    <Table striped hover>
      <thead>
        <tr>
          <td>Número de orden</td>
          <td>Fecha</td>
          <td>Estatus</td>
          <td>Monto</td>
          <td>Acciones</td>
        </tr>
      </thead>
      <tbody>
        {renderOrders()}
      </tbody>
    </Table>
    <OrderDetailsModal
      show={!!modalOrder && !showPayModal} 
      handleClose={hideModal} 
      handlePay={modalOrder?.order_status === 'Pago pendiente' ? launchPayModal : null}
      order={modalOrder}
    />
    <OrderPaymentModal 
      show={!!modalOrder && showPayModal} 
      handleClose={hideModal} 
      onPayment={onPayment}
      order={modalOrder}
    />
  </>;
}

export default ComunidadOrderHistory;